var Global = {
    url: 'https://pokeapi.co/api/v2/'
};

export default Global;